import React from 'react';
import {MultiSelectComponent, MultiSelectComponentProps} from "module/CustomField/component/input/MultiSelectComponent";

const options = [
	{
		displayName: 'Ja',
		value: 'J' as 'J',
	}, {
		displayName: 'Nein',
		value: 'N' as 'N',
	}, {
		displayName: 'Löschen',
		value: null,
		isButton: true,
		valueHighlight: false,
	},
];

export function JaNeinNullComponent(props: Omit<MultiSelectComponentProps<'J' | 'N' | null>, 'options'>) {
	return <MultiSelectComponent {...props} options={options}/>;
}